function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6595 3.97101C15.2981 3.3686 14.6471 3 13.9445 3H10.0555C9.35293 3 8.70192 3.3686 8.34047 3.97101L7.65952 5.10592C7.29808 5.70833 6.64706 6.07693 5.94454 6.07693H4C2.89543 6.07693 2 6.97236 2 8.07693V18.6923C2 19.7969 2.89543 20.6923 4 20.6923H20C21.1046 20.6923 22 19.7969 22 18.6923V8.07693C22 6.97236 21.1046 6.07693 20 6.07693H18.0555C17.3529 6.07693 16.7019 5.70833 16.3405 5.10592L15.6595 3.97101Z"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3405 5.10592L15.0542 5.87767L16.3405 5.10592ZM15.6595 3.97101L16.9458 3.19926L15.6595 3.97101ZM8.34047 3.97101L7.05423 3.19927L8.34047 3.97101ZM10.0555 4.5H13.9445V1.5H10.0555V4.5ZM8.94576 5.87767L9.62671 4.74275L7.05423 3.19927L6.37328 4.33418L8.94576 5.87767ZM4 7.57693H5.94454V4.57693H4V7.57693ZM3.5 18.6923V8.07693H0.5V18.6923H3.5ZM20 19.1923H4V22.1923H20V19.1923ZM20.5 8.07693V18.6923H23.5V8.07693H20.5ZM18.0555 7.57693H20V4.57693H18.0555V7.57693ZM14.3733 4.74275L15.0542 5.87767L17.6267 4.33418L16.9458 3.19926L14.3733 4.74275ZM18.0555 4.57693C17.8798 4.57693 17.7171 4.48478 17.6267 4.33418L15.0542 5.87767C15.6868 6.93189 16.826 7.57693 18.0555 7.57693V4.57693ZM23.5 8.07693C23.5 6.14394 21.933 4.57693 20 4.57693V7.57693C20.2761 7.57693 20.5 7.80079 20.5 8.07693H23.5ZM20 22.1923C21.933 22.1923 23.5 20.6253 23.5 18.6923H20.5C20.5 18.9685 20.2761 19.1923 20 19.1923V22.1923ZM0.5 18.6923C0.5 20.6253 2.067 22.1923 4 22.1923V19.1923C3.72386 19.1923 3.5 18.9685 3.5 18.6923H0.5ZM4 4.57693C2.067 4.57693 0.5 6.14394 0.5 8.07693H3.5C3.5 7.80079 3.72386 7.57693 4 7.57693V4.57693ZM6.37328 4.33418C6.28292 4.48478 6.12017 4.57693 5.94454 4.57693V7.57693C7.17396 7.57693 8.31323 6.93189 8.94576 5.87767L6.37328 4.33418ZM13.9445 4.5C14.1202 4.5 14.2829 4.59215 14.3733 4.74275L16.9458 3.19926C16.3132 2.14504 15.174 1.5 13.9445 1.5V4.5ZM10.0555 1.5C8.82604 1.5 7.68676 2.14505 7.05423 3.19927L9.62671 4.74275C9.71707 4.59215 9.87983 4.5 10.0555 4.5V1.5Z",
  fill: "#627080",
  mask: "url(#path-1-inside-1)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.1731,
  cy: 13.1731,
  r: 3.23077,
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgCamera = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Camera.09c18628.svg";
export { ForwardRef as ReactComponent };